import { AxiosResponse } from 'axios';
import { SET_GUIDELINES, SET_GUIDELINE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_GUIDELINE_ISLOADING,
  DELETE_GUIDELINE,
  EDIT_GUIDELINE,
  GET_GUIDELINES,
  GET_GUIDELINE,
  REGISTER_GUIDELINE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Guideline from '@/services/guideline';
import { Module } from 'vuex';
import { EditGuideline, RegisterGuideline, GetGuideline } from '@/dtos/guideline.dto';

const guideline: Module<any, {}> = {
  state: {
    guideline: {
      data: null,
      isLoading: false,
    },
    guidelines: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    guideline: (state: { guideline: any }) => state.guideline,
    guidelines: (state: { guidelines: any }) => state.guidelines,
  },
  mutations: {
    [SET_GUIDELINE]: (
      state: { guideline: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.guideline.data = payload.data) : null,
        (state.guideline.isLoading = payload.isLoading);
    },
    [SET_GUIDELINES]: (
      state: { guidelines: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.guidelines.data = payload.data) : null,
        (state.guidelines.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_GUIDELINE]: async ({ commit }: any, payload: any) => {
      commit(SET_GUIDELINE, { data: null, isLoading: true });

      const result: AxiosResponse = await Guideline.registerGuideline(
        payload as RegisterGuideline
      );

      if (result) {
        if (result.data.status) {
          commit(SET_GUIDELINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_GUIDELINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_GUIDELINE, { isLoading: false });
        return false;
      }
    },
    [GET_GUIDELINES]: async ({ commit }: any, payload: any) => {
      commit(SET_GUIDELINES, { data: null, isLoading: true });

      const result: AxiosResponse = await Guideline.getGuidelines(
        payload as GetGuideline
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_GUIDELINES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_GUIDELINES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_GUIDELINES, { isLoading: false });
        return false;
      }
    },
    [GET_GUIDELINE]: async ({ commit }: any, payload: any) => {
      commit(SET_GUIDELINE, { data: null, isLoading: true });

      const result: AxiosResponse = await Guideline.getGuidelines(
        payload as GetGuideline
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_GUIDELINE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_GUIDELINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_GUIDELINE, { isLoading: false });
        return false;
      }
    },
    [EDIT_GUIDELINE]: async ({ commit }: any, payload: any) => {
      commit(SET_GUIDELINE, { data: null, isLoading: true });

      const result: AxiosResponse = await Guideline.editGuideline(
        payload as EditGuideline
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_GUIDELINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_GUIDELINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_GUIDELINE, { isLoading: false });
        return false;
      }
    },
    [DELETE_GUIDELINE]: async ({ commit }: any, payload: string) => {
      commit(SET_GUIDELINE, { data: null, isLoading: true });

      const result: AxiosResponse = await Guideline.deleteGuideline(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_GUIDELINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_GUIDELINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_GUIDELINE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_GUIDELINE_ISLOADING]: ({ commit }) => {
      commit(SET_GUIDELINE, { isLoading: false });
      commit(SET_GUIDELINES, { isLoading: false });
    },
  },
};

export default guideline;
